import { useSetting } from './useSetting';
import type { SettingKey, SettingValue } from './settingsRegistry';
import type { SettingContext } from './settingTypes';

/**
 * A screen's setting through the model when `enabled` (a feature flag, and
 * whatever the context needs, such as a piece being open), and the screen's
 * own value and setter otherwise, so a screen moves onto the model behind a
 * flag without changing what it does with the flag off.
 */
export function useSettingWhenEnabled<K extends SettingKey>(
  enabled: boolean,
  key: K,
  context: SettingContext,
  screenState: [SettingValue<K>, (value: SettingValue<K>) => void],
): [SettingValue<K>, (value: SettingValue<K>) => void] {
  const modelState = useSetting(key, context);
  return enabled ? modelState : screenState;
}
